import {
  BEHAVIOR_EXTERNAL_LINK,
  INTERACTION_STYLE_PRIMARY,
  INTERACTION_STYLE_SECONDARY,
  INTERACTION_STYLE_TEXT,
} from 'components/modules/website-component-interaction/constants';

export function generateButtonMarkdown({ url, style, behaviorType, label } = {}) {
  const classByStyle = {
    [INTERACTION_STYLE_PRIMARY]: 'primary',
    [INTERACTION_STYLE_SECONDARY]: 'secondary',
    [INTERACTION_STYLE_TEXT]: 'default',
  };

  return (
    `<a class="ui button ${classByStyle[style]}" href="${url}"` +
    ` target=${behaviorType === BEHAVIOR_EXTERNAL_LINK ? '"_blank"' : '"_self"'}` +
    ` role="button">${label}</a>`
  );
}
